import React, { useState } from "react";
import {
  Button,
  TextField,
  DialogTitle,
  Dialog,
  Typography,
  IconButton,
} from "@mui/material";
import Box from "@mui/material/Box";
import { useTheme } from "@mui/material/styles"; // Import useTheme
import { useDispatch } from "react-redux";
import { v4 as uuidv4 } from "uuid";
import { addNewIngredient, saveCurrentRecipe } from "../actions/recipes";
import { Close } from "@mui/icons-material";

// Removed: import { makeStyles } from "@mui/styles";
// Removed: useStyles definition

function AddIngredient(props) {
  const { onClose, open } = props;
  const dispatch = useDispatch();
  const theme = useTheme(); // Access the theme

  const [name, setName] = useState("");
  const [amount, setAmount] = useState("");
  const [measurement, setMeasurement] = useState("");

  // --- Handlers ---
  const handleClose = () => {
    // Reset state before closing
    setName("");
    setAmount("");
    setMeasurement("");
    onClose();
  };

  const handleNameChange = (e) => setName(e.target.value);
  const handleAmountChange = (e) => setAmount(e.target.value);
  const handleMeasurementChange = (e) => setMeasurement(e.target.value);

  // --- Add Ingredient Logic ---
  function addIngredient() {
    if (!name || !amount || !measurement) {
      alert("Please fill in all fields.");
      return;
    }

    const newIngredient = {
      uuid: uuidv4(),
      // Ensure amount is stored as a number
      amount: parseFloat(amount),
      name: name,
      measurement: measurement,
    };

    dispatch(addNewIngredient(newIngredient));
    dispatch(saveCurrentRecipe());
    handleClose();
  }

  // Define styles using the sx prop
  const closeButtonStyle = {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  };
  const inputStyle = { mb: 2 }; // Consistent margin-bottom for inputs

  return (
    <Dialog
      maxWidth={"xs"}
      fullWidth={true}
      onClose={handleClose}
      aria-labelledby="add-ingredient"
      open={open}
    >
      <DialogTitle
        id="add-ingredient"
        sx={{
          borderBottom: `1px solid ${theme.palette.divider}`,
          padding: theme.spacing(2, 3),
        }}
      >
        <Typography variant="h5" component="span" sx={{ fontWeight: 600 }}>
          ➕ Add New Ingredient
        </Typography>
        <IconButton
          aria-label="close"
          sx={closeButtonStyle}
          onClick={handleClose}
        >
          <Close />
        </IconButton>
      </DialogTitle>

      <Box
        component="form"
        noValidate
        autoComplete="off"
        sx={{
          p: 4,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <TextField
          fullWidth
          label="Name"
          placeholder="e.g., Flour, Sugar, Chicken"
          onChange={handleNameChange}
          value={name}
          sx={inputStyle}
        />

        <TextField
          fullWidth
          label="Measurement"
          placeholder="e.g., cup, tsp, oz"
          onChange={handleMeasurementChange}
          value={measurement}
          sx={inputStyle}
        />

        <TextField
          fullWidth
          label="Amount"
          type="number"
          placeholder="Enter the quantity"
          inputProps={{ step: 0.1 }}
          onChange={handleAmountChange}
          value={amount}
          sx={inputStyle}
        />
      </Box>

      <Box
        sx={{
          p: 3,
          display: "flex",
          justifyContent: "center",
          borderTop: `1px solid ${theme.palette.divider}`,
        }}
      >
        <Button
          onClick={addIngredient}
          size="large"
          variant="contained"
          color="primary"
          sx={{ padding: theme.spacing(1, 4) }}
        >
          Add Ingredient
        </Button>
      </Box>
    </Dialog>
  );
}
export default AddIngredient;
